import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import { Url } from "../../Services/Api";
import { RxCross1 } from "react-icons/rx";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import prodIcon from '../../Assets/product-empty.webp'


export default function Flyer2({ onPayloadChange, flyerData, setFlyerData, error }) {

    const [loading, setLoading] = useState(true);


    /* ===============================
       FETCH FLYER DATA
    =============================== */
    useEffect(() => {

        fetchBannersMedia();
    }, []);


    /* ===============================
       ADD NEW MIDDLE PAGE
    =============================== */
    const addSimplePage = () => {
        const newPage = { products: new Array(8).fill(null) };

        const pages = flyerData.pages;

        const updatedPages = [
            pages[0],
            ...pages.slice(1, pages.length - 1),
            newPage,
            pages[pages.length - 1]
        ];

        setFlyerData({ ...flyerData, pages: updatedPages });
    };

    /* ===============================
       REMOVE MIDDLE PAGE
    =============================== */
    const removeSimplePage = (index) => {

        const updatedPages = flyerData.pages.filter((_, i) => i !== index);

        setFlyerData({
            ...flyerData,
            pages: updatedPages
        });
    };

    /* ===============================
       ADD PRODUCT TO SLOT
    =============================== */
    const addProductToPage = (pageIndex, slotIndex, product) => {

        if (!product) return;

        const updatedPages = flyerData.pages.map((page, pIndex) => {

            if (pIndex !== pageIndex) return page;

            const updatedProducts = page.products
                ? [...page.products]
                : new Array(8).fill(null);

            updatedProducts[slotIndex] = product;

            return {
                ...page,
                products: updatedProducts
            };
        });

        setFlyerData(prev => ({
            ...prev,
            pages: updatedPages
        }));
    };

    /* ===============================
       DRAG DROP HANDLER
    =============================== */
    const handleDropToPage = (pageIndex, slotIndex, e) => {
        e.preventDefault();

        const data = e.dataTransfer.getData("product");
        if (!data) return;

        const product = JSON.parse(data);

        addProductToPage(pageIndex, slotIndex, product);
    };




    const [showBannerSelection, setShowBannerSelection] = useState(false);
    const [showBannerSelection0, setShowBannerSelection0] = useState(0);
    const [selectedViewBanner, setSelectedViewBanner] = useState(0);
    const [isBannerImgUploading, setIsBannerImageUploading] = useState(false);
    const [selectedBannerImage, setSelectedBannerImage] = useState(null)
    const [openToust, setOpenToust] = useState(false);
    const [message, setMessage] = useState("");

    const handleOpenToust = (message) => {
        setOpenToust(true);
        setMessage(message);

        const timeout = setTimeout(() => {
            setOpenToust(false);
        }, 1500);
        return () => clearTimeout(timeout);
    }

    const handleCloseToust = () => {
        setOpenToust(false);
    }

    const [bannerImgForm, setBannerImgForm] = useState({
        image: null,
    });

    const [preview, setPreview] = useState(null);
    const handleFileClick = () => {
        fileInputRef.current.click();
    };

    const fileInputRef = useRef();
    // Handle image selection
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setBannerImgForm({ image: file });
            setPreview(URL.createObjectURL(file));
        }
    };


    const [bannersMedia, setBannersMedia] = useState([]);
    const fetchBannersMedia = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${Url}/api/v1/media/flyers/get`);
            console.log(response)
            const getAllMediaBanners = response?.data?.media || [];
            setBannersMedia(getAllMediaBanners);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoading(false);
        }
    };

    // Submit form with image only
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!bannerImgForm.image) {
            return setMessage('Please upload an image.');
        }

        const data = new FormData();
        data.append('image', bannerImgForm.image); // Match multer field name
        setIsBannerImageUploading(true);
        try {
            const response = await axios.post(`${Url}/api/v1/media/flyers/add`, data, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            setMessage(response.data.message);
            setBannerImgForm({ image: null })
            setPreview(null)
            await fetchBannersMedia()
            setIsBannerImageUploading(false);
            setSelectedViewBanner(0)
        } catch (error) {
            setMessage(error?.response?.data?.message || 'Upload failed.');
            setIsBannerImageUploading(false);
        }
    };

    const applyBanner = (banner) => {

        if (!banner) return;

        setSelectedBannerImage(banner);

        // ✅ Update flyerData with banner
        if (showBannerSelection0 === 0) {
            setFlyerData(prev => ({
                ...prev,
                banner_url: banner?.image_url   // 🔥 STORE BANNER INSIDE PAYLOAD
            }));
        } else if (showBannerSelection0 === 1) {
            setFlyerData(prev => ({
                ...prev,
                banner_url_2: banner?.image_url   // 🔥 STORE BANNER INSIDE PAYLOAD
            }));
        }

        setShowBannerSelection(false);
        setShowBannerSelection0(null)
    };

    useEffect(() => {

        if (onPayloadChange && flyerData) {
            onPayloadChange(flyerData);
        }

    }, [flyerData, selectedBannerImage]);

    /* =============================== */
    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error}</div>;
    if (!flyerData) return null;

    const pages = flyerData.pages;


    return (
        <div className="flyer_2">

            {/* ===============================
                FRONT PAGE (DRAG ENABLED)
            =============================== */}
            {/* FRONT PAGE (SMART FROM API) */}
            <div className="page_front_flyer_2 flyer_2_page">

                <div className="header_banner_flyer_2" onClick={() => { setShowBannerSelection0(0); setShowBannerSelection(true) }}>
                    {flyerData?.banner_url && (
                        <img
                            src={Url + flyerData?.banner_url}
                            alt="Banner"
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    )}
                </div>

                <div
                    className="flyer_2_products_staggered"
                    onDragOver={(e) => e.preventDefault()}
                >

                    {Array.from({ length: 6 }).map((_, slotIndex) => {

                        const product = pages[0]?.products?.[slotIndex];

                        const backgroundImage = product?.images?.[1]?.image_url;

                        return (
                            <div
                                key={slotIndex}
                                className="product_f2 bg_product_box"
                                onDrop={(e) =>
                                    handleDropToPage(0, slotIndex, e)
                                }
                                onDragOver={(e) => e.preventDefault()}
                                style={{
                                    backgroundImage: product
                                        ? `url(${Url + backgroundImage})`
                                        : "none"
                                }}
                            >

                                {product ? (
                                    <>
                                        <div className="product_overlay">
                                            <p>{product.name}</p>
                                            <span>${product.sale_price}</span>

                                        </div>
                                        {product.sku && (
                                            <div className="sku_badge">
                                                {product.sku}
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className="empty_product_box">
                                        <img src={prodIcon} alt="" srcset="" />
                                        <p>Search & Drag Product Here</p>
                                    </div>
                                )}

                            </div>
                        );
                    })}

                </div>

            </div>

            {/* ===============================
                MIDDLE PAGES (EDITABLE)
            =============================== */}
            {pages.slice(1, pages.length - 1).map((page, index) => {

                const actualIndex = index + 1;

                return (
                    <div
                        key={index}
                        className="page_simple_flyer_2 flyer_2_page"
                    >

                        <button
                            className="delete_btn"
                            onClick={() =>
                                removeSimplePage(actualIndex)
                            }
                        >
                            Delete Page
                        </button>

                        {Array.from({ length: 8 }).map((_, slotIndex) => {

                            const product = page.products?.[slotIndex];
                            const backgroundImage =
                                product?.images?.[1]?.image_url ||
                                product?.image?.image_url;

                            return (
                                <div
                                    key={slotIndex}
                                    className="product_f2_simple bg_product_box"
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={(e) =>
                                        handleDropToPage(actualIndex, slotIndex, e)
                                    }
                                    style={{
                                        backgroundImage: product
                                            ? `url(${Url + (backgroundImage)})`
                                            : "none"
                                    }}
                                >

                                    {product ? (
                                        <>
                                            <div className="product_overlay">
                                                <p>{product.name}</p>
                                                <span>${product.sale_price}</span>

                                            </div>
                                            {product.sku && (
                                                <div className="sku_badge">
                                                    {product.sku}
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="empty_product_box">
                                            <img src={prodIcon} alt="" srcset="" />
                                            <p>Search & Drag Product Here</p>
                                        </div>
                                    )}

                                </div>
                            );
                        })}

                    </div>
                );
            })}

            {/* ===============================
                ADD PAGE BUTTON
            =============================== */}
            <button
                className="add_page_btn"
                onClick={addSimplePage}
            >
                + Add Page
            </button>

            {/* LAST PAGE (SMART FROM API) */}
            <div className="page_last_flyer_2 flyer_2_page">

                <div
                    className="flyer_2_products_staggered"
                    onDragOver={(e) => e.preventDefault()}
                >

                    {Array.from({ length: 6 }).map((_, slotIndex) => {

                        const lastPageIndex = pages.length - 1;
                        const product = pages[lastPageIndex]?.products?.[slotIndex];

                        const backgroundImage =
                            product?.images?.[1]?.image_url ||
                            product?.image?.image_url;

                        return (
                            <div
                                key={slotIndex}
                                className="product_f2 bg_product_box"
                                onDrop={(e) =>
                                    handleDropToPage(lastPageIndex, slotIndex, e)
                                }
                                onDragOver={(e) => e.preventDefault()}
                                style={{
                                    backgroundImage: product
                                        ? `url(${Url + backgroundImage})`
                                        : "none"
                                }}
                            >

                                {product ? (
                                    <>
                                        <div className="product_overlay">
                                            <p>{product.name}</p>
                                            <span>${product.sale_price}</span>

                                        </div>
                                        {product.sku && (
                                            <div className="sku_badge">
                                                {product.sku}
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <div className="empty_product_box">
                                        <img src={prodIcon} alt="" srcset="" />
                                        <p>Search & Drag Product Here</p>
                                    </div>
                                )}

                            </div>
                        );
                    })}

                </div>

                <div className="header_banner_flyer_2" onClick={() => { setShowBannerSelection0(1); setShowBannerSelection(true) }}>
                    {flyerData?.banner_url_2 && (
                        <img
                            src={Url + flyerData?.banner_url_2}
                            alt="Banner"
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                    )}
                </div>
            </div>


            {showBannerSelection &&

                <div className="backdrop">
                    <div className="select_banner_ptag">
                        <div>
                            <button className="close_btn_product" onClick={() => { setShowBannerSelection(false); setShowBannerSelection0(null) }} ><RxCross1 /></button>
                        </div>

                        <h2>Banner</h2>

                        <div className="tab_section_main">
                            <div className={selectedViewBanner === 0 ? "tab_section active" : "tab_section"} onClick={() => {
                                setSelectedViewBanner(0)
                            }}>
                                Select Banner
                            </div>
                            <div className={selectedViewBanner === 1 ? "tab_section active" : "tab_section"} onClick={() => {
                                setSelectedViewBanner(1)
                            }}>
                                Upload Banner
                            </div>
                        </div>

                        {selectedViewBanner === 1 && <div style={{ margin: 'auto', marginTop: "20px", position: "relative" }}>
                            {preview ? <div></div> : <div
                                className="close_btn_product_upload"
                                style={{}}
                                onClick={handleFileClick}
                            >
                                <FiUpload /> Upload Image
                            </div>}

                            {/* Hidden file input */}
                            <input
                                type="file"
                                accept="image/*"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleImageChange}
                            />

                            {/* Image preview */}
                            {preview && <img src={preview} className="selected_uploaded_banner" alt="Preview" style={{ marginBottom: '10px' }} />}
                            {/* Submit button */}
                            {preview && <form onSubmit={handleSubmit} encType="multipart/form-data">
                                <button className="upload_image_btn_pop" type="submit">{isBannerImgUploading ? <div style={{ borderTop: "4px solid var(--Dark-Blue)" }} className="btn-loader-Publish"></div> : "Upload"}</button>
                            </form>}

                            {
                                preview && <div className="remove_uploaded_banner_img" onClick={() => { setPreview(null); setBannerImgForm({ image: null }) }} ><RxCross1 /></div>
                            }
                        </div>}


                        {selectedViewBanner === 0 && <div className="banners_list">

                            {

                                bannersMedia.map((item) => (
                                    <div
                                        key={item._id}
                                        className={`banner_image ${selectedBannerImage?._id === item._id ? "active" : ""}`}
                                        onClick={() => setSelectedBannerImage(item)}
                                    >
                                        <img src={Url + item.image_url} alt={`Banner ${item._id}`} />
                                    </div>
                                ))
                            }
                        </div>}


                        <div className="bottom_bar_popup">
                            <button className="updt_btn" onClick={() => applyBanner(selectedBannerImage)}>Okay</button>
                        </div>
                    </div>
                </div>}

        </div>
    );
}